var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#8D8E97",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.358 0 0 3.358 0 7.5 0 11.642 3.358 15 7.5 15c4.142 0 7.5-3.358 7.5-7.5C15 3.358 11.642 0 7.5 0m0 1.508c3.303 0 5.992 2.689 5.992 5.992s-2.689 5.992-5.992 5.992S1.508 10.803 1.508 7.5 4.197 1.508 7.5 1.508",
    transform: "translate(-1199.000000, -719.000000) translate(946.000000, 165.000000) translate(253.000000, 554.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.458 3.694l-.321 5.358c-.022.37-.345.654-.72.631-.348-.02-.619-.296-.639-.631l-.32-5.358c-.033-.546.388-1.015.941-1.047.552-.033 1.026.384 1.058.93.003.038.003.08 0 .117m-.249 7.445c0 .41-.336.742-.75.742-.415 0-.75-.332-.75-.742 0-.409.335-.741.75-.741.414 0 .75.332.75.741",
    transform: "translate(-1199.000000, -719.000000) translate(946.000000, 165.000000) translate(253.000000, 554.000000) translate(7.457556, 7.262860) scale(1, -1) translate(-7.457556, -7.262860)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsInfo);
export default __webpack_public_path__ + "static/media/icons-info.a3d660a74a0e239a85d11f01f4e4892a.svg";
export { ForwardRef as ReactComponent };